import styled from 'styled-components';
import {
  WrapperButtons,
  ApplyButton,
} from '../../../components/ModelInstanceFilter';
import { useFilterGroupContext } from './FilterGroupContext';
import FilterGroupChildPane from './FilterGroupChildPane';

const FilterGroupContent: React.FC = () => {
  const {
    orderedChildFilters,
    activeChildKey,
    commitSelections,
    clearSelections,
  } = useFilterGroupContext();

  return (
    <PanesColumn>
      {orderedChildFilters.map(([childKey, child]) => (
        <FilterGroupChildPane
          key={childKey}
          childKey={childKey}
          child={child}
          active={childKey === activeChildKey}
        />
      ))}
      <WrapperButtons>
        <ApplyButton size="small" type="link" onClick={clearSelections}>
          Clear
        </ApplyButton>
        <ApplyButton size="small" type="primary" onClick={commitSelections}>
          Apply
        </ApplyButton>
      </WrapperButtons>
    </PanesColumn>
  );
};

export default FilterGroupContent;

const PanesColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 200px;
`;
